<template>
  <auth-layout>
    <oxd-text class="gsl-hrm-login-title" tag="h5">
      {{ $t('auth.multifactorauthlang') }}
    </oxd-text>
    <div class="gsl-hrm-login-form">
      <div class="gsl-hrm-login-error">
        <oxd-alert
          :show="error !== null"
          :message="error?.message || ''"
          type="error"
        ></oxd-alert>
      </div>
      <oxd-form
        ref="multiFactorAuthenticationForm"
        method="post"
        :action="submitUrl"
        @submit-valid="onSubmit"
      >
        <input name="_token" :value="token" type="hidden" />
        <oxd-form-row>
          <oxd-input-field
            v-model="authenticationPin"
            name="authenticationPin"
            :label="$t('general.authenticationPinEnterMessage')"
            label-icon="key"
            :placeholder="$t('auth.authenticationPinEnterKey')"
            :rules="rules.authenticationPin"
            type="password"
            autofocus
          />
        </oxd-form-row>
        <oxd-form-actions class="gsl-hrm-login-action">
          <oxd-button
            class="gsl-hrm-login-button"
            display-type="main"
            :label="$t('general.verify')"
            type="submit"
          />
        </oxd-form-actions>
      </oxd-form>
      <br />
    </div>
    <div class="gsl-hrm-login-footer">
      <slot name="footer"></slot>
    </div>
  </auth-layout>
</template>

<script>
import {urlFor} from '@ohrm/core/util/helper/url';
import {required} from '@ohrm/core/util/validation/rules';
import {reloadPage} from '@ohrm/core/util/helper/navigation';
import AuthLayout from '../components/AuthLayout';
import {OxdAlert} from '@ohrm/oxd';
export default {
  name: 'MultiFactor',
  components: {
    'oxd-alert': OxdAlert,
    'auth-layout': AuthLayout,
  },
  props: {
    error: {
      type: Object,
      default: () => null,
    },
    token: {
      type: String,
      required: true,
    },
    showSocialMedia: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      authenticationPin: '',
      rules: {
        authenticationPin: [required],
      },
      submitted: false,
    };
  },

  computed: {
    submitUrl() {
      return urlFor('/auth/validateMultiFactor');
    },
  },

  beforeMount() {
    setTimeout(() => {
      reloadPage();
    }, 1200000); // 20 * 60 * 1000 (20 minutes);
  },
  methods: {
    onSubmit() {
      if (!this.submitted) {
        this.submitted = true;
        this.$refs.multiFactorAuthenticationForm.$el.submit();
      }
    },
  },
};
</script>
<style src="./login.scss" lang="scss" scoped></style>
